var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
import * as daterangepicker from 'daterangepicker';
import * as moment from 'moment';
export class DatePicker extends Component {
    constructor() {
        super('DatePicker', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            $('.date-picker').each((element) => {
                DatePicker.init(element);
            });
            this.success();
        });
    }
    static init(element) {
        const datepicker = new daterangepicker(element.get(0), {
            singleDatePicker: true,
            autoUpdateInput: false,
            autoApply: true,
            locale: {
                format: 'DD.MM.YYYY',
                daysOfWeek: [
                    'Di',
                    'Lu',
                    'Ma',
                    'Me',
                    'Je',
                    'Ve',
                    'Sa'
                ],
                monthNames: [
                    'Janvier',
                    'Février',
                    'Mars',
                    'Avril',
                    'Mai',
                    'Juin',
                    'Juillet',
                    'Août',
                    'Septembre',
                    'Octobre',
                    'Novembre',
                    'Décembre'
                ],
                'firstDay': 1
            }
        });
        element.on('apply.daterangepicker', function () {
            // Add the following line to node_modules/daterangepicker/daterangepicker.js ~ line 1402
            // this.element.get(0).dispatchEvent(new Event('apply.daterangepicker')); 
            const startDate = moment(datepicker.startDate).format('DD.MM.YYYY');
            element.val(startDate).trigger('change');
        });
    }
}
